/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TreatmentHistoryCategoryEnum } from './treatmentHistoryCategoryEnum';
import { TreatmentHistoryEntry } from './treatmentHistoryEntry';


/**
 * Diagnosis entry; nested under its appointment when it has one.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface DiagnosisTreatmentHistoryEntry { 
    readonly category: TreatmentHistoryCategoryEnum;
    readonly key: string;
    readonly date: string;
    readonly therapistName: string | null;
    readonly children: Array<TreatmentHistoryEntry>;
    readonly diagnosisId: number;
    readonly code: string;
    readonly certaintySuffix: string;
    readonly description: string;
}
export namespace DiagnosisTreatmentHistoryEntry {
}

export const DiagnosisTreatmentHistoryEntry_category_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_key_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_date_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_therapistName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_children_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_diagnosisId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_code_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_certaintySuffix_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTreatmentHistoryEntry_description_Validators: ValidatorFn[] =
    [  Validators.required, ];


